import { call, put, takeEvery } from "redux-saga/effects";
import { toast, Zoom } from "react-toastify";
import i18n from 'i18n';

import {
    GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID,
} from "./actionTypes"

import {
    getMerchantPaymentDetailByTransactionProvisionSettleGuidSuccess,
    merchantPaymentDetailApiError
} from "./actions"

import {
    getMerchantPaymentDetailByTransactionProvisionSettleGuid
} from "../../helpers/backend_helper/backend_helper"

function* onGetMerchantPaymentDetailByTransactionProvisionSettleGuid({ payload: transactionProvisionSettleGuid }) {
    try {
      const response = yield call(getMerchantPaymentDetailByTransactionProvisionSettleGuid, transactionProvisionSettleGuid)
      yield put(getMerchantPaymentDetailByTransactionProvisionSettleGuidSuccess(response))
    } catch (error) {
      yield put(merchantPaymentDetailApiError(error))
    }
  }

  function* merchantPaymentDetailSaga() {

    yield takeEvery(GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID, onGetMerchantPaymentDetailByTransactionProvisionSettleGuid)
}

export default merchantPaymentDetailSaga